/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { FinishedDisposition } from './FinishedDisposition';
import {
    instanceOfFinishedDisposition,
    FinishedDispositionFromJSON,
    FinishedDispositionFromJSONTyped,
    FinishedDispositionToJSON,
} from './FinishedDisposition';
import type { OnHoldDisposition } from './OnHoldDisposition';
import {
    instanceOfOnHoldDisposition,
    OnHoldDispositionFromJSON,
    OnHoldDispositionFromJSONTyped,
    OnHoldDispositionToJSON,
} from './OnHoldDisposition';

/**
 * @type CompleteEncounterRequestDisposition
 * What happens to the episode when the stay ends
 * @export
 */
export type CompleteEncounterRequestDisposition = FinishedDisposition | OnHoldDisposition;

export function CompleteEncounterRequestDispositionFromJSON(json: any): CompleteEncounterRequestDisposition {
    return CompleteEncounterRequestDispositionFromJSONTyped(json, false);
}

export function CompleteEncounterRequestDispositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteEncounterRequestDisposition {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfFinishedDisposition(json)) {
        return FinishedDispositionFromJSONTyped(json, true);
    }
    if (instanceOfOnHoldDisposition(json)) {
        return OnHoldDispositionFromJSONTyped(json, true);
    }
    return {} as any;
}

export function CompleteEncounterRequestDispositionToJSON(json: any): any {
    return CompleteEncounterRequestDispositionToJSONTyped(json, false);
}

export function CompleteEncounterRequestDispositionToJSONTyped(value?: CompleteEncounterRequestDisposition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfFinishedDisposition(value)) {
        return FinishedDispositionToJSON(value as FinishedDisposition);
    }
    if (instanceOfOnHoldDisposition(value)) {
        return OnHoldDispositionToJSON(value as OnHoldDisposition);
    }
    return {};
}

